<ng-container *ngIf="cardSourceBibs$ | async as cardSourceBibs">
  <div class="source-bib-actions">
    <button
      *roleVisibility="['create', 'update']; classNames: classNames"
      type="button"
      mat-raised-button
      (click)="addSourceBibHandler(cardSourceBibs[cardSourceBibs.length - 1])">
      {{ 'Aggiungi fonte' | translate }}
    </button>
  </div>
  <div [formGroup]="form">
    <ui-draggable-list
      *ngIf="cardSourceBibs.length > 0; else noItems"
      [items]="cardSourceBibs"
      (dropComplete)="orderSourceBinHandler($event)">
      <ng-template
        uiListItem
        let-bib="item"
        let-i="index">
        <div class="bib-container">
          <div
            class="bib-actions"
            *roleVisibility="['create', 'update']; classNames: classNames">
            <button
              mat-icon-button
              type="button"
              (click)="removeSourceBibHandler(bib, i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
          <div class="img-container" *ngIf="bib.docBib.immagine"
             >
            <img loading="lazy" [src]="fileUrl+bib.docBib.immagine">
          </div>
          <div
            class="bib-info-container"
            [formArrayName]="i">
            <div>
              <p class="bib-info">
                {{ 'Codice unico' | translate }}: {{ bib?.docBib.codiceUnico }}
              </p>
              <mat-form-field class="bib-info">
                <input
                  matInput
                  formControlName="riferimento"
                  [placeholder]="'Riferimento' | translate">
              </mat-form-field>
            </div>
            <div>
              <small class="bib-info">
                {{ 'Titolo' | translate }}: {{ bib?.docBib.titolo  }}
              </small>
              <small class="bib-info">
                {{ 'Autore' | translate }}: {{ bib?.docBib.autore?.join(', ') }}
              </small>
              <small class="bib-info">
                {{ 'Tags' | translate }}: {{ bib?.docBib.tag?.join(', ') }}
              </small>
            </div>
          </div>
          <div class="bib-navigate">
            <button
              mat-icon-button
              type="button"
              [routerLink]="['/bibs-sources', 'manager', bib?.docBib.id ]">
              <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>
        </div>
      </ng-template>
    </ui-draggable-list>

    <ng-template #noItems>
      <ui-no-items [size]="40"></ui-no-items>
    </ng-template>
  </div>
</ng-container>
